import { SharedCollection, SharedPhoto } from '../types/SharedCollection';

/** Email-tracked views plus session link opens (matches owner analytics). */
export function getCombinedViewCount(
   c: Pick<SharedCollection, 'viewCount' | 'linkOpenCount'>,
): number {
   return (c.viewCount || 0) + (c.linkOpenCount || 0);
}

/** Sum of contextual like counts across all photos in the collection (full set, not URL subset). */
export function getTotalCollectionLikes(photos: SharedPhoto[]): number {
   return photos.reduce((sum, p) => sum + (p.likeCount || 0), 0);
}
